import React , {useState} from 'react';
import { withStyles } from "@material-ui/core/styles";
import styles from './styles';
import { Button,  Divider,  List } from '@material-ui/core';
import SidebarItemComponent from '../sidebaritem/sidebaritem';

function SidebarComponent ({selectedNoteIndex,notes,selectedNote,selectNote,deleteNote,newNote,classes}){
   
    const [addingNote, setAddingNote] = useState(false);
    const [ title , setTitle ] = useState(null);

    const newNoteBtnClicked = ()=>
    {
        setTitle(null);
        setAddingNote(!addingNote)
    }

    const submitNote = ()=>{
       newNote(title)
       newNoteBtnClicked()
    }


    const updateTitle = (txt) =>{
        setTitle(txt);
    }

   // const DeleteNote = (note)=> deleteNote(note);

        if(notes){
            return(
                <div className={classes.sidebarContainer}>
                    <Button
                    onClick={newNoteBtnClicked}
                    className={classes.newNoteBtn}>
                        {addingNote ? 'Cancel': 'New Note'}
                    </Button>
                    {
                        addingNote ? (
                        <div>
                            <input type='text'
                            className={classes.newNoteInput}
                             placeholder="Enter the title for new note"
                             onKeyUp={(e) => updateTitle(e.target.value)} ></input>
                        <Button 
                        className={classes.newNoteSubmitBtn}
                        onClick={submitNote}>Submit Note</Button>
                         </div> ) : 
                         null
                    }
                    <List>
                        {
                            notes.map((_note , _index) => {
                                return(
                                    <div key={_index}>
                                        <SidebarItemComponent
                                            _note={_note}
                                            _index={_index}
                                            selectedNoteIndex={selectedNoteIndex}
                                            selectNote={selectNote}
                                            deleteNote={deleteNote}
                                        >
                                        </SidebarItemComponent>
                                        <Divider></Divider>
                                    </div>
                                )
                            })
                        }
                    </List>
                </div>
                );
                
                }
                else{
                    return( <div></div> )
        }
}


export default withStyles(styles)(SidebarComponent);